import React from 'react';
import { BarometerChartComponent, WithNeedleChart } from '../../components/WithNeedleChart';
import BarometroDetailsScreen from '../../screen/BarometroDetailsScreen';

const BarometroDetailsContainer = () => {
  return <BarometroDetailsScreen/>
}

export default BarometroDetailsContainer;